import { Theme } from '@mui/material/styles';

export default function Typography({ spacing }: Theme) {
  return {
    MuiTypography: {
      styleOverrides: {
        gutterBottom: {
          marginBottom: spacing(2),
        },
      },
    },
  };
}
